module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318833.10a61790.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318833.pdf
// module id = 844
// module chunks = 0